const GENDER_OPTIONS = [
  { value: 'regGenderMale', key: 'Male' },
  { value: 'regGenderFemale', key: 'Female' },
];

export default GENDER_OPTIONS;
